import { render, staticRenderFns } from "./GasError.vue?vue&type=template&id=8a5e1bce&scoped=true&"
import script from "./GasError.vue?vue&type=script&lang=js&"
export * from "./GasError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5e1bce",
  null
  
)

export default component.exports